import React, { PureComponent } from 'react';
import { Country } from '~/Api/Country';
import { Link } from '~/UI/Button';
import CountryIcon from '~/UI/CountryIcon/CountryIcon';

import styles from './styles.less';

interface Props {
	country: Country | null;
	link: { pathname: string; search: string };
}

export default class EmptyRow extends PureComponent<Props> {
	render() {
		const { country, link } = this.props;

		return (
			<div className={styles.emptyRow}>
				<div className={styles.addOrRemoveCell} />
				<div className={styles.countryCell}>
					{country && (
						<span className={styles.countryCellContent}>
							<div className={styles.countryIcon}>
								<CountryIcon code={country.alpha2} name={country.name} />
							</div>

							{country?.alpha2 || ''}
						</span>
					)}
				</div>
				<div className={styles.brandCellEmpty}>
					<span className={styles.emptyRowCellContent}>
						No referencing product selected for the country. <Link to={link}>Search for product</Link>
					</span>
				</div>
			</div>
		);
	}
}
